export const createNativeAction = (actionType, payloadCreator = (...args) => args || {}) => (...args) => Object.assign({
  name: actionType
}, payloadCreator(...args) || {});